/************
 * Model Class
 * File Name ...: unit-of-measure.components.ts
 * Generated By : ianday on 12/14/23
 * Date ........: 12/14/23
 /************/
import {ValidationResult} from './validation-result';

export interface UnitOfMeasure {
    id: number | null;
    description: string | null;
    activeStatus: string | null;
}

export class UnitOfMeasure {
    constructor() {
        this.id = 0;
        this.description = '';
        this.activeStatus = '';
    }

    validateRecord(): ValidationResult {
        const vr: ValidationResult = new ValidationResult();

        if (this.description.length === 0) {
            vr.focus_field = 'description';                              /* this should be the id value of the field */
            vr.error = 'Error: a description / value is required';
            return vr;
        }

        return vr;
    }
}
